import { toast } from "sonner";
import { trpc } from "@/lib/trpc";

/** Ligar/desligar serviço e categoria do catálogo, com o que precisa ser recarregado: a lista do
 *  laboratório e o cardápio que o dentista vê no pedido. */
export function useLigarServicos() {
  const utils = trpc.useUtils();
  const recarregar = () => {
    utils.prosthesis.catalog.myServiceCategories.invalidate();
    utils.prosthesis.catalog.serviceCategories.invalidate();
  };
  const servico = trpc.prosthesis.catalog.setServiceCategoryEnabled.useMutation({
    onSuccess: recarregar,
    onError: (e) => toast.error(e.message || "Erro ao atualizar serviço."),
  });
  const categoria = trpc.prosthesis.catalog.setServiceGroupEnabled.useMutation({
    onSuccess: recarregar,
    onError: (e) => toast.error(e.message || "Erro ao atualizar a categoria."),
  });
  return {
    ligarServico: (serviceCategoryId: string, enabled: boolean) => servico.mutate({ serviceCategoryId, enabled }),
    ligarCategoria: (group: string, enabled: boolean) => categoria.mutate({ group, enabled }),
    ocupado: servico.isPending || categoria.isPending,
  };
}
